import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityAddAttributeScope } from '../../projectDetailsActivities.models';

export const AddAttributeScopeActivity = ({ values }: IProjectActivity<IProjectActivityAddAttributeScope>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_AddAttributeScope')}
      <b>{values.scope}</b> {t('activity_description_common.to')} {t('activity_description_common.attribute')} <b>{values.attribute}</b>.
    </span>
  );
};
